import { getSundayAdjustedWeekNumber } from '~/utils/dateUtils/dateUtils';

const dateHelper = {
    getWeekNumber: (dateString, format) => {
        return getSundayAdjustedWeekNumber(dateString, format);
    },
};

export { dateHelper };
